import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=b2aa5814&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.vue?vue&type=style&index=0&id=b2aa5814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aa5814",
  null
  
)

export default component.exports